module.exports = __webpack_public_path__ + "static/img/training_camp.e1568975.svg";